import { Link } from "react-router-dom";
import { LogoMark, BRAND_TAGLINE, BRAND_PARENT } from "@/components/Brand";
import { CONTACT } from "@/components/LegalLayout";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-3">
              <LogoMark className="w-9 h-9" />
              <div className="leading-tight">
                <span className="font-display font-extrabold tracking-tight block">Futuregen Innovations</span>
                <span className="text-[11px] text-muted-foreground block" data-testid="footer-parent-brand">{BRAND_PARENT}</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {BRAND_TAGLINE}. Trusted support for UK CQC &amp; Ofsted registered managers, clinical aesthetics clinics and new start-ups.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">Platform</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/assistant" className="hover:text-foreground">AI Assistant</Link></li>
              <li><Link to="/resources" className="hover:text-foreground">Resource Store</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
              <li><Link to="/updates" className="hover:text-foreground">Regulatory Updates</Link></li>
              <li><Link to="/guidance" className="hover:text-foreground" data-testid="footer-guidance-link">Guidance articles</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">For Start-ups</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/start-up" className="hover:text-foreground">Registration Roadmap</Link></li>
              <li><Link to="/resources" className="hover:text-foreground">Start-up Toolkit</Link></li>
              <li><Link to="/resources" className="hover:text-foreground">Mock Interviews</Link></li>
              <li><Link to="/suppliers" className="hover:text-foreground" data-testid="footer-suppliers-link">Find a supplier</Link></li>
              <li><Link to="/advertise" className="hover:text-foreground" data-testid="footer-advertise-link">Advertise with us</Link></li>
              <li><Link to="/partner" className="hover:text-foreground" data-testid="footer-partner-link">Partner portal</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3">Sectors</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/cqc" className="hover:text-foreground" data-testid="footer-sector-cqc">CQC · Adult social care</Link></li>
              <li><Link to="/ofsted" className="hover:text-foreground" data-testid="footer-sector-ofsted">Ofsted · Children's services</Link></li>
              <li><Link to="/aesthetics" className="hover:text-foreground" data-testid="footer-sector-aesthetics">Clinical Aesthetics · CQC</Link></li>
              <li><Link to="/gp-hospitals" className="hover:text-foreground" data-testid="footer-sector-healthcare">GP & Hospitals · CQC</Link></li>
              <li><Link to="/fostering" className="hover:text-foreground" data-testid="footer-sector-fostering">Fostering Agencies · Ofsted</Link></li>
            </ul>
            <h4 className="font-semibold text-sm mb-3 mt-6">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/privacy" className="hover:text-foreground" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-foreground" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
              <li><Link to="/cookies" className="hover:text-foreground" data-testid="footer-cookies-link">Cookie Notice</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <div className="text-center sm:text-left" data-testid="footer-company-details">
            <p>© {new Date().getFullYear()} {CONTACT.company}, registered in {CONTACT.registeredIn}, company no. {CONTACT.companyNo}</p>
            <p data-testid="footer-registered-office">Registered office: {CONTACT.address}</p>
            <p data-testid="footer-contact"><a href={`mailto:${CONTACT.email}`} className="hover:text-foreground">{CONTACT.email}</a> · {CONTACT.phone}</p>
            <p className="mt-1">General guidance only — not formal legal advice.</p>
          </div>
          <span>UK-based support</span>
        </div>
      </div>
    </footer>
  );
}
